import React, { useEffect, useState } from 'react';
import Button from 'shared/components/Button';
import * as yup from 'yup';
import api from 'shared/services/api';
import { toast } from 'react-toastify';
import ListHeading from 'shared/components/ListHeading';
import AppContent from 'shared/components/AppContent';
import { useHistory, useParams } from 'react-router';
import { routes } from 'shared/constants/routes';
import useFetch from 'shared/hooks/useFetch';
import DeleteRecommendationModal from '../DeleteRecommendationModal';
import { useForm } from '@mantine/form';
import { useTranslations } from 'shared/translations/useTranslations';
import { get } from 'lodash';
import RecommendationCategoryForm from '../Form';

const schema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
});
interface Props {}

interface RecommendationCategory {
  name: string;
  translations: {
    [key: string]: {
      [key: string]: string;
    };
  };
}
interface Data {
  recommendationCategory: RecommendationCategory;
}
const Details = (props: Props) => {
  const translations = useTranslations();
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isLoaded, error, refresh } = useFetch<Data>({
    initialValue: { recommendationCategory: {} },
    fetchAction: () => api({}).get(`/api/admin/recommendations/categories/${id}`),
  });

  const form = useForm({
    initialValues: {
      name: undefined,
      translations: [
        { lang: 'pl', name: undefined },
        { lang: 'en', name: undefined },
        { lang: 'de', name: undefined },
        { lang: 'it', name: undefined },
        { lang: 'ru', name: undefined },
      ],
    },

    validate: {},
  });
  useEffect(() => {
    if (data?.recommendationCategory?.translations) {
      const translations = form.values.translations.map((translation, key) => {
        return {
          ...translation,
          name: get(data?.recommendationCategory?.translations, `${translation.lang}.name`),
        };
      });
      form.setValues({
        name: data?.recommendationCategory?.name,
        translations: translations,
      });
    } else {
      form.setValues({
        name: data?.recommendationCategory?.name,
        translations: [
          { lang: 'pl', name: data?.recommendationCategory?.name },
          { lang: 'en', name: data?.recommendationCategory?.name },
          { lang: 'de', name: data?.recommendationCategory?.name },
          { lang: 'it', name: data?.recommendationCategory?.name },
          { lang: 'ru', name: data?.recommendationCategory?.name },
        ]
      });
    }
  }, [data?.recommendationCategory]);

  const [isSaving, setSaving] = useState(false);
  const history = useHistory();
  const onSubmit = async (formValues: any) => {
    setSaving(true);
    try {
      const body = {
        name: formValues.name,
        translations: {
          pl: { name: '' },
          en: { name: '' },
          de: { name: '' },
          it: { name: '' },
          ru: { name: '' },
        },
      };
      formValues?.translations.forEach(translation => {
        body.translations[translation.lang].name = translation.name;
      });
      setSaving(false);
      await api({}).patch(`/api/admin/recommendations/categories/${id}`, body);
      toast.success(translations.recommendations.editRecommendationCategorySuccess);
      history.push(routes.admin.recommendation.default.path);
    } catch (e) {
      toast.error(translations.global.somethingWentWrong);
    }
  };

  return (
    <>
      <form
        onSubmit={form.onSubmit(values => {
          onSubmit(values);
        })}>
        <ListHeading title={translations.recommendations.editRecommendationCategory}>
          <div className="d-flex">
            <Button color="primary" className="ml-5" isLoading={isSaving}>
              {translations.global.save}
            </Button>
            <DeleteRecommendationModal id={id} />
          </div>
        </ListHeading>
        <AppContent>{isLoaded && <RecommendationCategoryForm form={form} />}</AppContent>
      </form>
    </>
  );
};

export default Details;
